import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VBtn,{attrs:{"color":"blue darken-1","text":"","disabled":_vm.isDisabled},on:{"click":_vm.Clicked}},[_vm._v("\n  "+_vm._s(_vm.buttonText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }